import ga from '../utils/ga'

export const reportVideoProgress = (eventName: string, videoSrc: string) => {
  ga('send', 'event', 'video player - search', eventName, videoSrc)
}

export const reportVideoFullscreen = (itemId: number) => {
  ga('send', {
    hitType: 'event',
    eventCategory: 'Video',
    eventAction: 'Full screen preview',
    eventLabel: `${itemId}`
  })
}
